const itemTypes = {
  ROW: 'row',
};

export default itemTypes;
